<div id="chart"
    class="chart-donut">
    <apx-chart [series]="chartOptions.series"
        [chart]="chartOptions.chart"
        [labels]="chartOptions.labels"
        [dataLabels]="chartOptions.dataLabels"
        [colors]="chartOptions.colors"
        [legend]="chartOptions.legend"
        [tooltip]="chartOptions.tooltip"
        [responsive]="chartOptions.responsive"
        class="d-flex justify-content-center">
    </apx-chart>
</div>